// @flow
import React from 'react';
import { connect } from 'react-redux';
import { Redirect, withRouter } from 'react-router-dom';
import ReduxToastr from 'react-redux-toastr';

import RouterComp from './route';
import HeaderWrapper from '../components/wrappers/headerWrapper/headerWrapper';
import UserContext from '../services/context/usercontext';

import { getUserProfile } from '../services/authService/authActionCreator';
import {
  initCalls,
  getLocations,
  getShopfloorZoneTypes,
  getReasons,
  setRouteSpecificFlags,
  getDirectDeliveryCount
} from '../services/initService/initServiceActionCreator';
import Loader from '../components/commons/loader/loader';
import config from '../configs/envConfig';
import { PanelConstants } from '../services/utils';
import { getCookie, redirectToPath, strUsables } from '../services/helpers';

type Props = {
  userProfile?: Object,
  getUserProfile: Function,
  history: Object,
  initCalls: Function,
  getLocations: Function,
  getShopfloorZoneTypes: Function,
  getReasons: Function,
  getDirectDeliveryCount: Function
};

const loadingText = 'Launching zoom ops...';

class App extends React.Component<Props> {
  componentDidMount() {
    sessionStorage.setItem(
      strUsables.accessToken,
      getCookie(strUsables.accessToken)
    );
    this.props.getUserProfile();
    this.props.setRouteSpecificFlags(this.props.history.location);
  }

  componentDidUpdate(prevProps, prevState): void {
    if (this.props && this.props.userProfile) {
      this.props.initCalls();
      this.props.getLocations();
      this.props.getReasons();
      this.props.getShopfloorZoneTypes();
      this.props.getDirectDeliveryCount();
    }
  }

  render() {
    if (this.props.userProfile) {
      if (window.location.pathname === '/' || window.location.pathname === '') {
        if (
          window.location.hostname === config.eRetailUrl &&
          window.location.pathname !== PanelConstants.newPrqPage
        ) {
          return (
            <Redirect
              to={{
                pathname: `${config.baseName}${PanelConstants.newPrqPage}`
              }}
            />
          );
        }
        return (
          <Redirect
            to={{
              pathname: `${config.baseName}${PanelConstants.defaultRoute}`
            }}
          />
        );
      }
      return (
        <div className="app-wrapper">
          <HeaderWrapper history={this.props.history} />
          <UserContext.Provider value={{ ...this.props.userProfile }}>
            <RouterComp
              userProfile={this.props.userProfile}
              history={this.props.history}
            />
          </UserContext.Provider>
          <ReduxToastr
            timeOut={4000}
            newestOnTop={true}
            preventDuplicates
            position="top-right"
            transitionIn="fadeIn"
            transitionOut="fadeOut"
          />
        </div>
      );
    }
    return <Loader message={loadingText} />;
  }
}

const mapStateToProps = state => ({
  userProfile: state.userProfile
});

const mapDispatchToProps = {
  getUserProfile,
  initCalls,
  getLocations,
  getShopfloorZoneTypes,
  getReasons,
  setRouteSpecificFlags,
  getDirectDeliveryCount
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App));
